import { type FC } from "react";

import { Button, Colors } from "@snapchat/snap-design-system";
import { MembersIcon } from "@snapchat/snap-design-system-icons";

import { useFeatureGates } from "../../../../cof-feature-gates/hooks";
import { CofConfigId } from "../../../../gql-generated/types";
import { PageHeader, PageHeaderContainer } from "../../../../layout/components";
import { LensFoldersPageBreadcrumbs } from "../../../../lens/components/shared";
import { Flexbox } from "../../../../shared/components";
import { BUSINESS_MANAGER_URL } from "../../../../shared/constants";
import {
    useSelectedLensCentralOrganizationNotIncludesCamkitOrgs,
    useSelectedLensFolder,
    useSelectedLensFolderV3,
} from "../../../../shared/hooks";
import { useSelectedOrganization } from "../../../../shared/hooks/useSelectedOrganization";
import { truncate } from "../../../../shared/styles";
import { openWindow } from "../../../../shared/utils/browser";

import {
    buttonContainer,
    contentContainer,
    folderName,
    headerContainer,
    manageMembersButton,
} from "./PageOrganizationHeader.styles";

const handleManageMembersButtonClick = (organizationId?: string) => {
    const businessManagerOrganizationUrl = `${BUSINESS_MANAGER_URL}/${organizationId}/settings/members`;
    openWindow(businessManagerOrganizationUrl);
};

export const PageOrganizationHeader: FC = () => {
    const selectedOrganizationV3 = useSelectedLensCentralOrganizationNotIncludesCamkitOrgs();
    const folder = useSelectedLensFolderV3();

    const { configs } = useFeatureGates();
    const isMyLensesOrgsV2Enabled = configs[CofConfigId.MyLensesOrgsV2].enabled;
    const selectedOrganization = useSelectedOrganization();
    const { lensFolder: folderV2 } = useSelectedLensFolder();

    const orgId = isMyLensesOrgsV2Enabled ? selectedOrganization?.id : selectedOrganizationV3?.id;
    const folderNameValue = isMyLensesOrgsV2Enabled ? folderV2?.name : folder?.name;

    return (
        <Flexbox className={headerContainer}>
            <Flexbox className={contentContainer}>
                <LensFoldersPageBreadcrumbs />
                <PageHeaderContainer>
                    <PageHeader className={`${truncate} ${folderName}`}>{folderNameValue}</PageHeader>
                </PageHeaderContainer>
            </Flexbox>
            <Flexbox className={buttonContainer}>
                <Button
                    type="primary"
                    className={manageMembersButton}
                    onClick={() => {
                        handleManageMembersButtonClick(orgId);
                    }}
                >
                    <MembersIcon fill={Colors.WHITE} />
                    Manage Members
                </Button>
            </Flexbox>
        </Flexbox>
    );
};
